<template>
  <div class="nav">
    <div class="logo-box">
      <i class="i-icon logo" @click="returnHome"></i>
      <div class="logo-title">
        <div>泓江科技</div>
        <div class="crumb-box" v-if="currentClass">
          <span class="crumb-item" @click="returnHome">全部训练</span>
          <span class="crumb-icon">/</span>
          <span>{{currentClass.ClassName}}</span>
        </div>
      </div>
    </div>
    <div class="nav-right">
      <div class="return" v-if="ptype=='person'" @click="returnHome()">返回首页</div>
      <div class="user-box" v-if="user">
        <a-dropdown :trigger="['click']">
          <i class="i-icon avatar" :style="{ backgroundImage: 'url(' + user?.HeadPhotoPath + ')' }"></i>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="() => { $router.push(`/personal`) }">
                <span>个人中心</span>
              </a-menu-item>
              <a-menu-item @click="logout()">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { PASSPORT_CLIENT_SERVER, LESSONPLAY_TOKEN, ONLINE_URL } from '../../config/url';

export default {
  name: "navroot",
  data() {
    return {
      user: null,
      currentClass: null
    }
  },
  props: {
    ptype: String
  },
  async mounted() {
    this.user = this.$store.state.userInfo;
    if (!this.user.Phone || !this.user.StudentID || !this.user.School) {
      this.openNotification();
    }

    this.$store.subscribe((res) => {
      if (!res) return;
      if (res.type == "userInfo") this.user = res.payload;
      if (res.type == "currentClass") this.currentClass = res.payload;
    });

  },
  methods: {
    //提示信息
    openNotification() {
      this.$notification.open({
        message: '提示',
        description: '您的个人信息不完善！请完善个人信息',
        top: '50px'
      });
    },
    //退出
    logout() {
      this.$confirm('确定要退出账号吗?', () => {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        window.localStorage.removeItem(LESSONPLAY_TOKEN);
        location.href = `${PASSPORT_CLIENT_SERVER}/auth/logout?token=${token}&redirectURI=${ONLINE_URL}&isTourist=true`;
      })
    },
    //跳转至个人中心
    personalCenter() {
      this.$router.push(`/personal`);
    },
    //跳转首页
    returnHome() {
      this.$router.push(`/classlist`);
    }
  }
}
</script>

<style scoped lang="scss">
@import "./nav.scss";
</style>